<template>
    <div class="user-list">
        <div class="table-info">
            <div class="breadcrumb">
            <span>位置：</span>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>用户权限</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
            <h3>角色权限</h3>
        </div>
        <div class="table-content">
            <div class="tool-bar">
                <span>关键字：</span>
                <el-input size="small" placeholder="请输入" width="264" class="key-word" v-model="keyword"></el-input>
                <span>状态：</span>
                <el-select v-model="status"  size="small" class="status">
                  <el-option
                    v-for="item in statusDatas"
                    :key="item.value"
                    :label="item.status"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="primary" size="small" @click="SearchRole()" v-if="isCompleted && isShowButton('查询')">查询</el-button>
                <el-button size="small" @click="resetData()" v-if="isCompleted && isShowButton('重置')">重置</el-button>
                <el-button size="small" type="primary" @click="handleOption('新增')" v-if="isCompleted && isShowButton('新增角色')">新增角色</el-button>
            </div>
             <el-table
                :data="tableData5"
                v-loading="loading"
                style="width: 100%">
                <el-table-column type="expand">
               <template slot-scope="props">
                 <el-form label-position="left" inline class="demo-table-expand">
                   <el-form-item label="角色描述">
                     <span>{{ props.row.describe }}</span>
                   </el-form-item>
                 </el-form>
               </template>
             </el-table-column>
                <el-table-column
                  label="角色名称"
                  prop="roleName" align="center">
                </el-table-column>
                <el-table-column
                  label="角色描述"
                  prop="describe" align="center">
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="80"
                  prop="status" align="center">
                </el-table-column>
                <el-table-column
                  label="修改时间"
                  prop="updateTime" align="center">
                </el-table-column>
                <el-table-column
                  label="添加时间"
                  prop="createTime" align="center">
                </el-table-column>
                <el-table-column
                  label="操作" align="center">
                  <!--v-if="scope.row.RoleName!='admin'"-->
                  <template slot-scope="scope">
                      <el-button type="text" @click="handleOption('编辑',scope.row)" v-if="isAdmin">编辑</el-button>
                      <!--<el-button type="text" @click="del(scope.row.ID)">删除</el-button>-->
                      <el-popover
                        placement="top"
                        width="172"
                        v-model="scope.row.isAbolish">
                        <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                          <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
                        </div>
                        <el-button class="marginLeft10" slot="reference" type="text" v-if="isAdmin">删除</el-button>
                      </el-popover>
                  </template>
                </el-table-column>
            </el-table>
          <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page.sync='PageIndex' :page-sizes='[10, 20, 50]'
                         :page-size='PageSize' layout='total, sizes, prev, pager, next, jumper' :total='total'>
          </el-pagination>
        </div>

        <el-dialog :title="title" :visible.sync="dialogShow" :before-close="handleClose">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-row>
              <el-col class="title" :span="4">角色名称：</el-col>
              <el-col :span="20">
                <el-form-item prop="roleName">
                  <el-input size="small" v-model="ruleForm.roleName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="title" :span="4">角色描述：</el-col>
              <el-col :span="20">
                <el-form-item prop="describe">
                  <el-input type="textarea" size="small" rows="5" v-model="ruleForm.describe"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="title" :span="4">角色级别：</el-col>
              <el-col :span="20">
                <el-form-item prop="level">
                  <el-select v-model="ruleForm.level" placeholder="请选择" size="small">
                    <el-option :key="1" label="超级管理员" :value="1"></el-option>
                    <el-option :key="2" label="普通管理员" :value="2"></el-option>
                    <el-option :key="3" label="普通用户" :value="3"></el-option>
                    <el-option :key="4" label="助教" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="title" :span="4">选择权限：</el-col>
            </el-row>
            <el-row>
              <!--<el-col :span="4">-->
                <el-tree
                  :data="powerData"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :check-change="changeTree"
                  :props="defaultProps">
                </el-tree>
              <!--</el-col>-->
            </el-row>
          </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button :disabled="isDisable" type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  data () {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      isAdmin:false,
      isDisable:false,
      powerData:[],//菜单下拉列表数据
      secondPowers:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      keyword:'',
      PageIndex:1, //当前页
      PageSize:10, //每页数量
      totalCache:0, //条数
      title:'',
      ruleForm:{},
      initForm:{
        id:'',
        roleName: '',
        describe: '',
        status:'',
        updateTime:'',
        createTime:'',
        level: ''
      },

      rules: {
        roleName: [{required:true,message:'请输入角色名称',trigger:'blur'},{max:20,message:'不能超过20个字符'}],
        describe: [{required:true,message:'请输入角色描述',trigger:'blur'},{max:100,message:'不能超过100个字符'}],
        userPower: [{required:true,message:'请选择权限',trigger:'blur'}],
      },
      status: '',
      statusDatas: [
        {status: "正常",value:1},
        {status: "禁用",value:2},
      ],
      dialogShow: false,  //弹框显示/隐藏
      // power: [],
      tableData5: [
      ]
    }
  },
  created(){
    this.getBtnRole()
    this.getPowerData()
    this.SearchRole()
    if(window.localStorage.getItem('LoginName')==='admin'){
      this.isAdmin=true
    }
  },
  computed: {
    total() {
      return this.totalCache
    }
  },
  methods: {
    changeTree(data, isCheck, a) {
      // console.log(data)
    },
    handleClose(done){
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancel(){
      this.dialogShow = false
      this.$refs.tree.setCheckedKeys([])
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.SearchRole()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.SearchRole()
    },
    // 点击编辑按钮
    handleOption(option,val) {
      // console.log('val', val)
      this.ruleForm = {}
      if(option==='新增'){
          this.title='新增角色'
          this.dialogShow = true
          this.ruleForm = this.initForm
      }else if(option === '编辑'){
          this.title = '编辑角色'
          this.ruleForm = val
          this.dialogShow = true
          this.Axios.get('/api/Auth/GetAuthByRoleID/'+val.id).then(res=>{
            // console.log('menuList',res.data.menuList)
            if(res.status === 200){
              // console.log('checkedMenu', res.data.menuList)
              // console.log('powerdata', this.powerData)
              let checkMenu = []
              // 所有选中节点的id
              for (let item of res.data.menuList) {
                const fatherId = item.menuID
                if (item.btnList.length > 0) {
                  for (let btnItem of item.btnList) {
                    checkMenu.push(btnItem.btnID + '&&' + fatherId)
                  }
                } else {
                  checkMenu.push(item.menuID)
                }
              }
              // console.log('筛选后的id', checkMenu)
              // this.$refs.tree.setCheckedKeys(checkMenu)

              // let checkedMenu = res.data.menuList.map(item => item.menuID)
              // for(let mitem of this.powerData){
              //   let count = 0
              //   for(let j of checkMenu){
              //     if(mitem.children.some(item => item.id == j)){
              //       count++
              //     }
              //   }
              //   if(count < mitem.children.length && count > 0){
              //     checkMenu.splice(checkMenu.indexOf(mitem.id), 1)
              //   }
              // }
              // console.log('筛选后的id', checkMenu)
              this.$refs.tree.setCheckedKeys(checkMenu)
            }
          })
      }
    },
    // 得到选中的树节点
    changPowers(){
      let keys = this.$refs.tree.getCheckedKeys()
      // console.log('keys', keys)
      let firstList = []
      firstList = this.secondPowers.filter(item=>{
        return keys.indexOf(item.id)>=0
      })
      for(let i=0;i<firstList.length;i++){
        keys.push(firstList[i].topMenuID)
      }
      let newList = Array.from(new Set(keys))
      // console.log('newList', newList)
      return newList
    },
    // 新增,编辑申请表单
    handleSubmit(formName) {
      // console.log(11111, this.changPowers())
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isDisable=true
          setTimeout(()=>{
            this.isDisable=false
          },1000)
        if(this.title==='新增角色'){
          const condition={
            roleName:this.ruleForm.roleName,
            describe:this.ruleForm.describe,
            level: this.ruleForm.level
          }
          this.Axios.post('/api/Role/AddRole', condition).then(res=>{
            // console.log(res.data)
            if(res.data.status == 100){
              const powers={
                masterID:res.data.message,
              }
              // 所有菜单id
              let checkMenu = []
              // 深拷贝数组
              checkMenu = this.changPowers().concat()
              // 得到菜单id
              let menuArr = checkMenu.filter(item => item.indexOf('&&') < 0)
              // 得到按钮id
              let btnArr = checkMenu.filter(item => item.indexOf('&&') != -1)
              // console.log('btnArr', btnArr)
              // 组合好的按钮菜单的集合
              let btnArrList = []
              // console.log('btnArr', btnArr)
              for (let item of btnArr) {
                let itemArr = item.split('&&')
                btnArrList.push({
                  id: itemArr[0],
                  fatherId: itemArr[1]
                })
              }
              // console.log('组合好的按钮菜单的集合', btnArrList)
              // console.log('菜单集合', menuArr)
              // console.log('所有菜单id', this.changPowers())
              // 组合后要传的菜单的集合
              let menuList = []
              let menuListCache = []
              // 子菜单没有全选完 不能得到父级id
              // if (menuArr.length == 0 && btnArrList.length > 0) {

              // }
              for (let item of btnArrList) {
                menuArr.push(item.fatherId)
                menuArr = Array.from(new Set(menuArr))
              }
              // console.log('没有父级菜单', menuArr)
              for (let i= 0; i < menuArr.length; i++) {
                const fatherId = menuArr[i]
                let btnArrr = []
                menuList[i] = {
                  menuID: menuArr[i],
                  btnList: []
                }
                for (let btnItem of btnArrList) {
                  if (btnItem.fatherId == fatherId) {
                    btnArrr.push({
                      btnID: btnItem.id,
                      isExist: true
                    })
                    menuList[i] = {
                      menuID: menuArr[i],
                      btnList: btnArrr
                    }
                  }
                }
              }
              powers.menuList = menuList
              // for (let mItem of this.changPowers()) {
              //   let btnArr = []
              //   if (mItem.indexOf("&&") != -1) {
              //     let mIdArr = mItem.split('&&')
              //     const fatherId = mIdArr[1]
              //     for (let i = 0; i < checkMenu.length; i++) {
              //       if (fatherId == checkMenu[i]) {
              //         btnArr.push({
              //           btnID: mIdArr[0],
              //           isExist: true
              //         })
              //         menuList.push({
              //           menuID: checkMenu[i],
              //           btnList: btnArr
              //         })
              //       }
              //     }
              //   } else if (mItem.indexOf("&&") < 0) {
              //     menuList.push({
              //       menuID: mItem,
              //       btnList: []
              //     })
              //   }
              // }

              // console.log('添加菜单', menuList)

              this.Axios.put('/api/Auth/UpdateAuth',powers).then(res=>{
                this.$message({
                  showClose: true,
                  message: '添加成功',
                  type: 'success'
                });
                this.SearchRole()
              })
            }
            this.$refs[formName].resetFields();
            this.dialogShow = false
            this.$refs.tree.setCheckedKeys([]);
          }).catch(error=>{
            console.log(error)
          })

        }else if(this.title==='编辑角色'){
            const condition2={
              roleName:this.ruleForm.roleName,
              describe:this.ruleForm.describe,
              level: this.ruleForm.level
            }
            this.Axios.put('/api/Role/UpdateRole/'+this.ruleForm.id, condition2).then(res=>{
              if(res.data.status === 100){
                const powers={
                  masterID:this.ruleForm.id,
                }
                // 所有菜单id
                let checkMenu = []
                // 深拷贝数组
                checkMenu = this.changPowers().concat()
                // 得到菜单id
                let menuArr = checkMenu.filter(item => item.indexOf('&&') < 0)
                // 得到按钮id
                let btnArr = checkMenu.filter(item => item.indexOf('&&') != -1)
                // console.log('btnArr', btnArr)
                // 组合好的按钮菜单的集合
                let btnArrList = []
                // console.log('btnArr', btnArr)
                for (let item of btnArr) {
                  let itemArr = item.split('&&')
                  btnArrList.push({
                    id: itemArr[0],
                    fatherId: itemArr[1]
                  })
                }
                // console.log('组合好的按钮菜单的集合', btnArrList)
                // console.log('菜单集合', menuArr)
                // console.log('所有菜单id', this.changPowers())
                // 组合后要传的菜单的集合
                let menuList = []
                let menuListCache = []
                // 子菜单没有全选完 不能得到父级id
                for (let item of btnArrList) {
                  menuArr.push(item.fatherId)
                  menuArr = Array.from(new Set(menuArr))
                }
                // console.log('没有父级菜单', menuArr)
                for (let i= 0; i < menuArr.length; i++) {
                  const fatherId = menuArr[i]
                  let btnArrr = []
                  menuList[i] = {
                    menuID: menuArr[i],
                    btnList: []
                  }
                  for (let btnItem of btnArrList) {
                    if (btnItem.fatherId == fatherId) {
                      btnArrr.push({
                        btnID: btnItem.id,
                        isExist: true
                      })
                      menuList[i] = {
                        menuID: menuArr[i],
                        btnList: btnArrr
                      }
                    }
                  }
                }
                powers.menuList = menuList

                powers.menuList = JSON.parse(JSON.stringify(menuList))
                this.Axios.put('/api/Auth/UpdateAuth',powers).then(res=>{
                  this.$message({
                    showClose: true,
                    message: '修改成功',
                    type: 'success'
                  });
                  this.SearchRole()
                  this.$refs.tree.setCheckedKeys([]);
                }).catch(()=>{
                  this.$message({
                    showClose: true,
                    message: '修改失败',
                    type: 'error'
                  });
                })
              }
            }).catch(err=>{
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              });
            })
            this.SearchRole()
            this.$refs[formName].resetFields();
            this.dialogShow = false
        }
        } else {
        this.dialogShow = true
        return false;
        }
      });
    },
    // 搜索
    SearchRole(){
      const conditions={
        pagesize:this.PageSize,
        start:this.PageIndex
      }
      if(this.keyword!=''){
        conditions.keyword=this.keyword
      }
      if(this.status!=''){
        conditions.status=this.status
      }
      this.loading = true
      this.Axios.get('/api/Role/SearchRole',{params:conditions}).then(res=>{
        if(res.status===200){
          this.tableData5=res.data.data
          this.totalCache=res.data.total
          this.loading = false
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 重置
    resetData(){
      this.keyword=''
      this.status=''
      this.SearchRole()
    },
    // 获取所有菜单id 封装数据格式
    getPowerData(){
      this.Axios.get('/api/Menu/GetAllMenuAndButtons').then(res=>{
        // console.log('res', res)
        if(res.status === 200){
          // 所有菜单
          const data = res.data
          // console.log(data)
          //一级菜单
          let levelOneMenu = data.filter(item => item.topMenuID == '')
          // 二级菜单
          let levelTwoMenu = data.filter(item => item.topMenuID != '')
          // console.log('一级菜单', levelOneMenu)
          // console.log('二级菜单', levelTwoMenu)
          // 二级菜单有按钮信息
          for (let item of levelTwoMenu) {
            item.children = []
            if (item.btnInfo) {
              for (let btnItem of item.btnInfo) {
                item.children.push({
                  id: btnItem.id + '&&' + item.id,
                  label: btnItem.name
                })
              }
            }
          }
          for (let item of levelOneMenu) {
            item.children = []
            item.label = item.menuName
            const fatherId = item.id
            if (item.btnInfo) {
              for (let btnItem of item.btnInfo) {
                item.children.push({
                  id: btnItem.id + '&&' + item.id,
                  label: btnItem.name
                })
              }
            }
            for (let noSubMenuItem of levelTwoMenu) {
              if (noSubMenuItem.topMenuID == fatherId) {
                item.children.push({
                  id: noSubMenuItem.id,
                  label: noSubMenuItem.menuName,
                  children: noSubMenuItem.children
                })
              }
            }
          }
          // console.log('组装好的数据', levelOneMenu)
          this.powerData = levelOneMenu


          // let powerData = []
          // for (let item of data) {
          //   if (item.topMenuID === '') {
          //     powerData.push({
          //       id: item.id,
          //       label: item.menuName,
          //       children: []
          //     })
          //   }
          // }
          // for (let item of data) {
          //   if (item.topMenuID !== '') {
          //     for (let power of powerData) {
          //       if (power.id === item.topMenuID) {
          //         power.children.push({
          //           id: `${item.id}&&${power.id}`,
          //           label: item.menuName,
          //           children: []
          //         })
          //       }
          //     }
          //   }
          // }
          // for (let item of data) {
          //   if (item.btnInfo) {
          //     for (let power of powerData) {
          //       if (item.id === power.id) {
          //         for (let btn of item.btnInfo) {
          //           power.children.push({
          //             id: `${btn.id}&&${power.id}`,
          //             label: btn.name,
          //             children: []
          //           })
          //         }
          //       } else {
          //         // for (let child of power.children) {
          //         //   for (let btn of item.btnInfo) {
          //         //     if (child.id === `${btn.id}&&${btn.menuID}`) {
          //         //       child.children.push({
          //         //         id: `${btn.id}&&${child.id}&&${power.id}`,
          //         //         label: btn.name,
          //         //         children: []
          //         //       })
          //         //     }
          //         //   }
          //         // }
          //       }
          //     }
          //   }
          // }
          // console.log(powerData)
          // this.powerData = powerData
        }
      }).catch(err=>{
        // console.log('err', err)
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员111',
          type: 'error'
        });
      })
    },
    // 删除角色
    del(id){
      this.Axios.delete('/api/Role/DeleteRole/'+id).then(res=>{
        if(res.data.status){
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
        }else{
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
        this.SearchRole()
      })
    },
  }
}
</script>

<style scoped lang="less">
.user-list{
  .breadcrumb{
    overflow:hidden;
    span,.el-breadcrumb{
      float:left;
    }
    span{
      font-size:14px;
      color:#666;
      line-height:1;
    }
  }
  .table-content{
    .tool-bar{
      padding:0 20px;
      span{
        font-size:14px;
        color:rgba(0,0,0,0.85);
        font-weight:400;
      }
      .key-word,.status{
        width:264px;
        margin-right:40px;
      }
    }
    .el-table{
      margin:20px 0;
      a{
        padding-right:15px;
      }
    }
    .el-pagination{
      /deep/ .number, /deep/ .btn-prev, /deep/ .btn-next{
        background-color:#fff;
        border:1px solid #d9d9d9;
        width:32px;
        height:32px;
      }
    }
  }
  .el-dialog__wrapper{
    /deep/ .el-dialog{
      width:520px;
    }
    .el-row{
      padding:15px 0;
    }
    .title{
      text-align:right;
      padding-top:10px;
    }
    .el-select{
      width:100%;
    }
    /deep/ .el-dialog__header{
      border-bottom:1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer{
      border-top:1px solid #d9d9d9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/UserManage/UserPower.vue